// ! ||--------------------------------------------------------------------------------||
// ! ||                                   PDP Offers                                   ||
// ! ||--------------------------------------------------------------------------------||
class ExtendProductOffer extends HTMLElement {
    constructor(productForm, addToCartButton) {
        super();

        const referenceId = productForm.id.value;
        this.product = (() => {
            return meta.product ?? meta.products?.find((product) => product.variants.find((variant) => variant.id = referenceId))
        })()
        const price = this.product.variants.filter(variant => variant.id == referenceId)[0].price;
        const category = this.product.type;

        this.params = {
            referenceId,
            price,
            category
        }
        
        this.config = getConfiguration();
        this.config.dispatchSideCart = false;
        
        this.productForm = productForm;
        this.addToCartButton = addToCartButton;
    }
    
    connectedCallback() {
        try {
            this.verifyProductOffer();
        } catch (err) {
            console.error(err.message);
            return;
        }
     
        this.bindEvents();
        this.style.display = 'block';
        
        if (!this.config.pdpOfferEnabled) this.style.display = 'none';
        // Renders Extend offer
        Extend.buttons.render(this, this.params);
    }
    
    bindEvents() {
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        
        this.productForm.addEventListener('change', this.handleVariantChange.bind(this), true);
    }
    
    verifyProductOffer() {

        let elementsToCheck = [
            'this.productForm',
            'this.addToCartButton',
            'this.params.referenceId',
            'this.params.price',
            'this.params.category'
        ]
        
        let missingElements = elementsToCheck.filter((value) => {
            try {
                return !eval(value);
            } catch (err) {
                return true;
            }
        });
        
        if (missingElements.length) {
            let message = "The following value(s) are null or undefined:\n";
            missingElements.forEach((value) => {
                message += `\t${value}\n`;
            });
            throw new ExtendError(message);
        }
        
        // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
        verifyExtend();
        
    }

    modalDone() {
        // remove default click listener
        this.addToCartButton.removeEventListener('click', this.handleAddToCart, true);
        // click atc button
        $(this.addToCartButton).trigger('click');
        // add default click listener back
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);

        // If variable set to true, dispatches Extend side cart integration to run after adding to cart via pdp
        if (this.config.dispatchSideCart) window.setTimeout(() => {
            initCartOffer();
        }, 500);
    }
    
    /**
    * Handle add to cart event with offers
    * @param {PointerEvent} e Click event from Add To Cart Button
    */
    handleAddToCart(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const quantityEl = this.productForm.querySelector('[name="quantity"]');
        const quantity = quantityEl && quantityEl.value ? quantityEl.value : 1;
    
        ExtendShopify.handleAddToCart(this, {
            quantity: quantity,
            modal: this.config.modalOfferEnabled,
            done: this.modalDone.bind(this)
        });

    }
    
    handleVariantChange() {
        // Flicker prevention

        this.params.referenceId = this.productForm.id.value;
        this.params.price = this.product.variants.filter(variant => variant.id == this.params.referenceId)[0].price;
        
        
        Extend.setActiveProduct(this, this.params);
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 250);
    }
}
if (!customElements.get('extend-offer'))
    customElements.define('extend-offer', ExtendProductOffer);

/**
* Initializes product offers and handles ATC button functionality for the main PDP ATC
*/
function initProductOffer(quickview = false) {
    try {
        if (!quickview && (meta.page.pageType != 'product' || !meta.product))
            throw new ExtendError("Extend Product Offer - The current page is not a product page");
    } catch (err) {
        console.warn(err.message);
        return;
    }

    const productFormSelector = 'form[data-product-form]';
    const addToCartButtonSelector = 'button[data-add-to-cart]';

    const productForm = document.querySelector(productFormSelector);
    const addToCartButton = productForm ? productForm.querySelector(addToCartButtonSelector) : document.querySelector(addToCartButtonSelector);
    // Create offer and render it
    const extendOffer = new ExtendProductOffer(productForm, addToCartButton);

    addToCartButton.parentElement.before(extendOffer);
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                Quickview Offers                                ||
// ! ||--------------------------------------------------------------------------------||

function initQuickView() {
    document.addEventListener('extend.render-quickview', () => {
        initProductOffer(true)
    });
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                   Cart Offers                                  ||
// ! ||--------------------------------------------------------------------------------||

const cartOfferTag = 'extend-cart-offer';
var cart;
var init = false;

const {
    cartOfferEnabled,
    cartSPEnabled,
    sideCartOfferEnabled,
    cartBalancingEnabled,
    SPEnabled
} = getConfiguration();

const isMobile = screen.width < 641

let type, selectors;
if (meta.page.pageType === 'cart' && (cartOfferEnabled || cartSPEnabled)) {
    selectors = {
        cartContainer: '.cart_items',
        cartRowItem: 'li[data-product_id]', // Container element for each item in the cart
        cartRowItemImage: '.product-img', // Product image or image anchor element
        cartRowItemVendor: '.product-vendor:not(.properties)',
        cartRowItemTitle: '.product-name', // Title anchor element for the product
        cartRowItemQuantity: `input[name="updates[]]`, // Input element containing the product quantity
        warrantyOriginalMeta: '.properties label,.size', // Each warranty metadata item we want to remove.
        offerAnchor: '.button-groups', // Container where the offer will be appended
        metadataContainer: '.properties', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: `.qty-group`, // Wrapper for quantity input and buttons
        shipping: {
            anchor: '.btn-actions'
        }
    }
    type = 'main';
} else if (sideCartOfferEnabled) {
    selectors = {
        cartContainer: '.products-list',
        cartRowItem: '.items', // Container element for each item in the cart
        cartRowItemImage: '.product-image', // Product image or image anchor element
        cartRowItemTitle: '.product-name', // Title anchor element for the product
        cartRowItemQuantity: '.qtt', // Input element containing the product quantity
        warrantyOriginalMeta: '.option span', // Each warranty metadata item we want to remove.
        offerAnchor: '.option', // Anchor that helps with offer position
        metadataContainer: '.option', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: '.quantity-selector', // Wrapper for quantity input and buttons
        lineItemRemove: '.btn-remove',
        shipping: {
            anchor: '.actions'
        }
    }
    type = 'side';
}

if (type === undefined || selectors === undefined) {
    throw new ExtendError('No cart type detected');
}

class ExtendCartOffer extends HTMLElement {
    
    constructor(referenceId, category, price, quantity, type) {
        super();
        this.params = {
            referenceId,
            category,
            price,
            quantity
        }
        this.type = type;

        this.config = getConfiguration();
    }
    
    connectedCallback() {
        if (!this.canDisplayOffer()) {
            return;
        }
        
        Extend.buttons.renderSimpleOffer(this, {
            ...this.params,
            onAddToCart: ({ plan, product }) => {
                ExtendShopify.addPlanToCart({
                    plan,
                    product,
                    quantity: this.params.quantity
                }, (err) => {
                    if (err) {
                        throw new ExtendError(err.message);
                    }
                    
                    document.dispatchEvent(new Event('extend.plan-added'));
                });
            }
        });
    }
    
    canDisplayOffer() {
        return (this.type === 'main' && this.config.cartOfferEnabled) || (this.type === 'side' && this.config.sideCartOfferEnabled);
    }
}
if (!customElements.get(cartOfferTag))
    customElements.define(cartOfferTag, ExtendCartOffer);

class CartShippingOffer extends HTMLElement {
    constructor(cart) {
        super();
        
        this.items = ExtendShopify.spCartMapper(cart.items);
        this.isShippingProtectionInCart = ExtendShopify.shippingProtectionInCart(cart.items);
        this.bindCallbacks();
    }
    
    bindCallbacks() {
        this.onEnable = this.onEnable.bind(this);
        this.onDisable = this.onDisable.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
    }
    
    connectedCallback() {
        Extend.shippingProtection.render({
            selector: this,
            items: this.items,
            isShippingProtectionInCart: this.isShippingProtectionInCart,
            onEnable: this.onEnable,
            onUpdate: this.onUpdate,
            onDisable: this.onDisable
        });
    }
    
    onEnable(quote) {
        let callback = (err) => {
            if (err) {
                throw new ExtendError(err.message)
            } else {
                document.dispatchEvent(new Event('extend.plan-added'));
            }
        };
        
        ExtendShopify.addSpPlanToCart({
            quote,
            callback: callback.bind(this)
        });
    }
    
    onDisable(quote) {
        let callback = (err, response) => {
            if (response.isUpdated) { 
                document.dispatchEvent(new Event('extend.plan-added'));
            } else if (err) {
                throw new ExtendError(err.message);
            } else {
                throw new ExtendError("SP not updated");
            }
        };
        
        ExtendShopify.updateSpPlanInCart({
            action: 'remove',
            quote,
            callback: callback.bind(this)
        });
    }
    
    onUpdate(quote) {
        // Do nothing
    }
    
    update(cart) {
        this.items = ExtendShopify.spCartMapper(cart.items);
        
        Extend.shippingProtection.update({
            items: this.items
        });
    }
    
    get checkbox() {
        return Extend.shippingProtection._instance.component.shippingCheckbox;
    }

    static tagName = 'extend-shipping';
}
if (!customElements.get('extend-shipping'))
    customElements.define('extend-shipping', CartShippingOffer);

function createShippingOffer() {
     let shippingOffer = document.querySelector(CartShippingOffer.tagName);
    if (!shippingOffer) {
        shippingOffer = new CartShippingOffer(cart);

        let anchor = document.querySelector(selectors.shipping.anchor);
        anchor.prepend(shippingOffer); // append, prepend, after, before
        return shippingOffer;
    } else {
        shippingOffer.update(cart);
    }
}

function createWarrantyOffer(lineItemElement, index) {
    if (!cartOfferEnabled) return;

    const cartItem = cart.items[index];
    const referenceId = cartItem.variant_id;
    const quantity = cartItem.quantity;
    const price = cartItem.price;
    const category = cartItem.product_type;
    const warrantyAlreadyInCart = ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items) || ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items);
    
    let anchor = lineItemElement.querySelector(selectors.offerAnchor);
    
    if (!anchor) {
        throw new ExtendError(`Offer anchor element on line ${index} not found with selector ${selectors.offerAnchor}`);
    }
    
    let extendOffer = lineItemElement.querySelector(cartOfferTag);
    
    // If there's already an offer element, check that the properties match what we are trying to create
    // If they do not match, or the warranty is already in cart, remove the offer
    if (extendOffer) {
        if (extendOffer.params.referenceId !== referenceId ||
            extendOffer.params.quantity !== quantity ||
            extendOffer.params.price !== price ||
            extendOffer.params.category !== category ||
            warrantyAlreadyInCart
        ) {
            extendOffer.remove();
            // If they do match and the warranty is not already in the cart, do not create a new offer
        } else {
            return;
        }
        // If there is no offer element, but the warranty is already in cart, do not create a new offer
    } else if (warrantyAlreadyInCart) {
        return;
    }
    
    let newExtendOffer = new ExtendCartOffer(referenceId, category, price, quantity, type);
    
    anchor.before(newExtendOffer); // append, prepend, after, before
}

function styleSPLineItem(lineItemElement) {
    lineItemElement.style.display = 'none';
}

function styleWarrantyLineItem(lineItemElement, index) {
    const title = lineItemElement.querySelector(selectors.cartRowItemTitle);
    title.style.pointerEvents = 'none';
    title.innerText = 'Extend Protection Plan';
    
    const image = lineItemElement.querySelector(selectors.cartRowItemImage);
    
    if (image) {
        image.style.pointerEvents = 'none';
    } else {
        console.error(`EXTEND: Line item image element on line ${index} not found with selector ${selectors.cartRowItemImage}`)
    }
    
    const warrantyMetadata = lineItemElement.querySelectorAll(selectors.warrantyOriginalMeta);
    
    if (warrantyMetadata?.length) {
        warrantyMetadata.forEach(each => {
            const property = each.innerHTML.trim();
            if (!property.startsWith('Product') && !property.startsWith('Term')) each.remove();
            else {
                each.classList.add('extend-warranty-info');
            }
        });
    }
    
    if (selectors.quantityWrapper?.length && lineItemElement.querySelector(selectors.quantityWrapper)) {
        lineItemElement.querySelectorAll(selectors.quantityWrapper).forEach((each) => {
            each.style.opacity = '75%';
            each.style.pointerEvents = 'none';
        });
    }

    const warrantyOptionsContainer = lineItemElement.querySelector(selectors.metadataContainer)

    if (warrantyOptionsContainer) {
        const coveredProduct = cart.items[index].properties.Product
        const termLength = cart.items[index].properties.Term

        warrantyOptionsContainer.innerHTML = `<div class="extend-warranty-info"><span>Product: </span><span>${coveredProduct}</span></div><div class="extend-warranty-info"><span>Term: </span><span>${termLength}</span></div>`
    }
}

function formatLineItems() {
    let cartContainer = document.querySelector(selectors.cartContainer);
    
    if (!cartContainer) {
        throw new ExtendError(`Invalid cart container selector: ${selectors.cartContainer}`);
    }
    
    cartContainer.querySelectorAll(selectors.cartRowItem).forEach((lineItemElement, index) => {
        let title = lineItemElement.querySelector(selectors.cartRowItemTitle);
        
        if (!title) {
            throw new ExtendError('Line item title not found');
        }
        
        let lowerCaseTitle = title.innerHTML.toLowerCase();
        
        if (lowerCaseTitle.includes('extend protection')) {
            styleWarrantyLineItem(lineItemElement, index);
        } else if (lowerCaseTitle.includes('extend shipping protection')) {
            styleSPLineItem(lineItemElement)
        } else {
            createWarrantyOffer(lineItemElement, index);
        }
    });   
}

function normalizeItems(callback) {
    if (SPEnabled) {
        ExtendShopify.updateExtendLineItems({
            balanceCart: cartBalancingEnabled,
            isSPSupported: cartSPEnabled,
            callback
        });
    } else {
        let normalizationOpts = {
            balance: cartBalancingEnabled
        }
        ExtendShopify.normalizeCart(normalizationOpts, callback);
    }
}

function refreshCart() {
    if (type === 'side') {
        document.dispatchEvent(new Event('extend.refresh-cart'));
    } else if (type === 'main') {
        location.reload();
    } else {
        window.location.reload();
    }
}

function verifyCartOffers() {
    verifyExtend();

    let error = '';
    if (!selectors) error = `Cart selectors are empty\n`;

    if (!type) error += `Cart type not defined\n`;

    if (error.length > 0) {
        throw new ExtendError(`Cannot initialize cart offers due to following errors:\n${error}`);
    }
}

function initEventListeners() {
    document.addEventListener('extend.cart-updated', () => {
        initCartOffer()
    });

    document.addEventListener('extend.plan-added', () => {
        refreshCart();
    });

    init = true;
}

function initCartOffer() {
    verifyCartOffers();

    try {
        if (!/cart/.test(window.location.pathname) && !sideCartOfferEnabled) {
            throw new ExtendError('Cannot initialize cart offers - not a cart page');
        }
    } catch (err) {
        console.warn(err.message);
        return;
    }

    if (!init) initEventListeners();

    normalizeItems((err, data) => {
        cart = data?.cart;
        if (err) {
            throw new ExtendError(err.message);
        }

        if (data?.updates) {
            refreshCart();
        } else {
            formatLineItems();
            createShippingOffer();
        }
    });
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                      Utils                                     ||
// ! ||--------------------------------------------------------------------------------||
class ExtendError extends Error {
    constructor(message) {
        super(message);
    }
}

function getConfiguration() {
    return {
        currency: 'USD',
        pdpOfferEnabled: true,
        offerModalEnabled: true,
        cartOfferEnabled: true,
        sideCartOfferEnabled: true,
        cartBalancingEnabled: true,
        aftermarketModalEnabled: true,
        atcOfferEnabled: true,
        quickviewOfferEnabled: true,
        quickviewModalOfferEnabled: true,
        cartSPEnabled: false,
        SPEnabled: false,
    };
}

function verifyExtend() {
    const propertiesToCheck = [
        'window.Extend',
        'window.ExtendShopify',
        'window.Shopify',
        'window.Shopify.currency.active'
    ];
    
    function checkPropertyExists(path) {
        return path.split('.').reduce((obj, prop) => obj && obj[prop], window) !== undefined;
    }
    
    let errors = propertiesToCheck.filter(prop => !checkPropertyExists(prop));
    
    // Check for currency mismatch
    if (window.Shopify?.currency?.active !== getConfiguration().currency) {
        errors.push('window.Shopify.currency.active == config.currency');
    }
    
    if (errors.length) {
        let message = "The following value(s) are null, undefined, or false:\n";
        errors.forEach((error) => {
            message += `\t${error}\n`;
        });
        throw new ExtendError(message);
    }
}

function initAftermarket() {
    try {
        verifyExtend();

        // Get params from URL
        const params = (new URL(document.location)).searchParams;

        // Check if leadToken or leadtoken is in the URL
        let leadToken = params.get('leadToken')
            ? params.get('leadToken')
            : params.get('leadtoken');

        if (leadToken) {
            Extend.aftermarketModal.open({
                leadToken: leadToken,
                onClose: function (plan, product, quantity) {
                    if (plan && product) {
                        ExtendShopify.addPlanToCart({
                            plan: plan,
                            product: product,
                            leadToken: leadToken,
                            quantity: quantity || 1
                        }, function () {
                            location = '/cart'
                        })
                    }
                }
            });
        }
    } catch (error) {
        throw new ExtendError( error.message);
    }
}

function getCart() {
    return fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(e => e.json());
}

// Integration init
window.addEventListener('load', () => {
    try {
        const storeId = '0bf71f26-0dc0-48b3-b03b-f4e5690e3f15';
        const environment = 'production';
        
        window.Extend.config({ storeId, environment});

        const config = getConfiguration();

        if (config.aftermarketModalEnabled)
            initAftermarket();

        if (config.atcOfferEnabled || config.offerModalEnabled || config.pdpOfferEnabled)
            initProductOffer();

        if (config.quickviewOfferEnabled)
            initQuickView();

        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
    } catch (err) {
        if (sessionStorage.getItem('extend.debug'))
            console.error(err);
    }
});